import {useCallback, useState, type DragEvent} from 'react'

/** Drag-and-drop handlers for a single image file; `dragOver` drives the highlight, `onHover` reports the pointer while dragging. */
export const useImageDropTarget = (
  onFile: (file: File, e: DragEvent<HTMLElement>) => void,
  onHover?: (e: DragEvent<HTMLElement>) => void,
) => {
  const [dragOver, setDragOver] = useState(false)

  const handleDragOver = useCallback(
    (e: DragEvent<HTMLElement>) => {
      if (!e.dataTransfer.types.includes('Files')) return
      e.preventDefault()
      setDragOver(true)
      onHover?.(e)
    },
    [onHover],
  )

  const handleDragLeave = useCallback(() => setDragOver(false), [])

  const handleDrop = useCallback(
    (e: DragEvent<HTMLElement>) => {
      e.preventDefault()
      e.stopPropagation()
      setDragOver(false)
      const file = e.dataTransfer.files?.[0]
      if (file) onFile(file, e)
    },
    [onFile],
  )

  return {dragOver, dropProps: {onDragOver: handleDragOver, onDragLeave: handleDragLeave, onDrop: handleDrop}}
}
